<template>
  <div class="relative w-full overflow-hidden rounded-lg shadow-lg" style="height: 400px;">
    <div
      class="flex h-full transition-transform duration-500 ease-in-out"
      :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
    >
      <div v-for="(image, index) in images" :key="index" class="flex-shrink-0 w-full h-full">
        <img :src="image.src" :alt="image.alt" class="object-cover w-full h-full" />
      </div>
    </div>

    <div class="absolute left-0 right-0 flex justify-center space-x-2 bottom-4">
      <button
        v-for="(image, index) in images"
        :key="index"
        class="w-3 h-3 transition-colors duration-300 rounded-full"
        :class="{ 'bg-blue-600': currentIndex === index, 'bg-gray-400': currentIndex !== index }"
        aria-label="Go to slide"
        @click="goToSlide(index)"
      />
    </div>

    <button
      class="absolute z-10 p-2 text-white transition-all duration-300 -translate-y-1/2 bg-gray-800 bg-opacity-50 rounded-full left-4 top-1/2 hover:bg-opacity-75"
      aria-label="Previous slide"
      @click="prevSlide"
    >
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" /></svg>
    </button>
    <button
      class="absolute z-10 p-2 text-white transition-all duration-300 -translate-y-1/2 bg-gray-800 bg-opacity-50 rounded-full right-4 top-1/2 hover:bg-opacity-75"
      aria-label="Next slide"
      @click="nextSlide"
    >
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" /></svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ImageSlider',
  props: {
    images: {
      type: Array,
      required: true,
      default: () => [],
      validator: (value) => value.every(img => typeof img.src === 'string' && typeof img.alt === 'string'),
    },
    autoplayInterval: {
      type: Number,
      default: 5000,
    },
  },
  data() {
    return {
      currentIndex: 0,
      autoplayTimer: null,
    }
  },
  mounted() {
    this.startAutoplay()
  },
  beforeUnmount() {
    this.stopAutoplay()
  },
  methods: {
    startAutoplay() {
      if (this.autoplayInterval > 0) {
        this.autoplayTimer = setInterval(this.nextSlide, this.autoplayInterval)
      }
    },
    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer)
        this.autoplayTimer = null
      }
    },
    goToSlide(index) {
      this.currentIndex = index
      this.stopAutoplay()
      this.startAutoplay()
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length
    },
    prevSlide() {
      this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length
    },
  },
}
</script>
